export const EQUALS = {
  name: "<b>==</b> (Equals)",
  value: "==",
};

export const NOT_EQUALS = {
  name: "<b>!=</b> (Not equals)",
  value: "!=",
};

export const GREATER_THAN = {
  name: "<b>></b> (Greater than)",
  value: ">",
};

export const LESS_THAN = {
  name: "<b><</b> (Less than)",
  value: "<",
};

export const GREATER_THAN_EQUAL_TO = {
  name: "<b>>=</b> (Greater than or equal to)",
  value: ">=",
};

export const LESS_THAN_EQUAL_TO = {
  name: "<b><=</b> (Less than or equal to)",
  value: "<=",
};

export const CONTAINS = {
  name: "<b>@=</b> (Contains)",
  value: "@=",
};

export const START_WITH = {
  name: "<b>_=</b> (Starts with)",
  value: "_=",
};

export const DOES_NOT_START_WITH = {
  name: "<b>!_=</b> (Does not Starts with)",
  value: "!_=",
};

export const CASE_INSENSITIVE_STRING_CONTAINS = {
  name: "<b>@=*</b> (Case-insensitive string Contains)",
  value: "@=*",
};

export const CASE_INSENSITIVE_STRING_START_WITH = {
  name: "<b>_=*</b> (Case-insensitive string Starts with)",
  value: "_=*",
};

export const CASE_INSENSITIVE_STRING_EQUALS = {
  name: "<b>==*</b> (Case-insensitive string Equals)",
  value: "==*",
};

export const CASE_INSENSITIVE_STRING_NOT_EQUALS = {
  name: "<b>!=*</b> (Case-insensitive string Not equals)",
  value: "!=*",
};

export const CASE_INSENSITIVE_STRING_DOES_NOT_CONTAINS = {
  name: "<b>!@=*</b> (Case-insensitive string does not Contains)",
  value: "!@=*",
};

export const CASE_INSENSITIVE_STRING_DOES_NOT_START_WITH = {
  name: "<b>!_=*</b> (Case-insensitive string does not Starts with)",
  value: "!_=*",
};
